import React, { createContext, useContext, ReactNode } from "react";
import { closeSnackbar, useSnackbar, VariantType } from "notistack";
import { IconButton, Typography } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";

type SnackbarHelperProps = {
  children: ReactNode;
};

const SnackbarContext = createContext<
  (message: string, variant?: VariantType) => void
>(() => {});

export const SnackbarHelper: React.FC<SnackbarHelperProps> = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar();

  const showSnackbar = (message: string, variant: VariantType = "default") => {
    let value = <Typography variant="subtitle1">{message}</Typography>;
    enqueueSnackbar(value, {
      variant,
      preventDuplicate: true,
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
      action: (key) => (
        <IconButton
          onClick={() => closeSnackbar(key)}
          size="small"
          color="inherit"
        >
          <GridCloseIcon fontSize="small" />
        </IconButton>
      ),
    });
  };

  return (
    <SnackbarContext.Provider value={showSnackbar}>
      {children}
    </SnackbarContext.Provider>
  );
};

export const useSnackbarHelper = () => {
  return useContext(SnackbarContext);
};
